(function () {
  'use strict';

  angular.module('app').component('transportationListSearch', transportationListSearch());

  function transportationListSearch() {
    return {
      bindings: {
        onTransportationScheduleSelected: '&',
        transportationIdSelected: '<',
        transportationScheduleIdSelected: '<',
        transportations: '<',
        showTransportationsSearch: '<',
      },
      controller: TransportationListSearchComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/transportation/components/transportation-list-search/transportation-list-search.component.html',
    };
  }

  TransportationListSearchComponent.$inject = ['CONFIGURATIONS', 'moment', 'TransportationService'];

  function TransportationListSearchComponent(config, moment, TransportationService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.hourDisplay = config.HOUR_DISPLAY;

    vm.filterByText = null;

    vm.$onInit = function () {
      if (!vm.transportationIdSelected) {
        getTransportations();
      } else {
        vm.filteredTours = vm.tours;
      }
    };

    vm.filterTransportations = function () {
      if (vm.filterByText || vm.departure_location_id || vm.arrival_location_id) {
        let transportationsFiltered = [];
        let transportationsCopy = angular.copy(vm.transportationsCopy);

        transportationsCopy.forEach(function (transportation) {
          if (
            (vm.filterByText && vm.filterByText !== '') ||
            (vm.departure_location_id &&
              transportation.departure_location_id === vm.departure_location_id) ||
            (vm.arrival_location_id &&
              transportation.arrival_location_id === vm.arrival_location_id)
          ) {
            let item;
            let itemFound = false;
            let res;

            if (vm.filterByText && vm.filterByText !== '') {
              res = searchTransportationsNamesByText(transportation);

              if (res.transportation_schedules.length > 0) {
                item = res;
                itemFound = true;
              }
            }

            if (!res) {
              item = transportation;
            }

            if (vm.departure_location_id || vm.arrival_location_id) {
              itemFound = false;

              if (vm.departure_location_id && vm.arrival_location_id) {
                if (
                  vm.departure_location_id === item.departure_location_id &&
                  vm.arrival_location_id === item.arrival_location_id
                ) {
                  itemFound = true;
                }
              } else {
                if (
                  vm.departure_location_id &&
                  vm.departure_location_id === item.departure_location_id
                ) {
                  itemFound = true;
                }

                if (vm.arrival_location_id && vm.arrival_location_id === item.arrival_location_id) {
                  itemFound = true;
                }
              }
            }

            if (itemFound) {
              transportationsFiltered.push(item);
            }
          }
        });

        vm.filteredTransportations = transportationsFiltered;
      } else {
        vm.filteredTransportations = vm.transportations;
      }
    };

    vm.clearSearch = function () {
      vm.filterByText = '';

      vm.transportations = vm.filteredTransportations;

      // vm.transportations = vm.transportationsCopy;
    };

    vm.selectTransportationSchedule = function (transportation, transportationSchedule) {
      // Avoid calling the date of it is the same schedule
      if (vm.transportationScheduleIdSelected === transportationSchedule.id) {
        return;
      }

      vm.transportationIdSelected = transportation.id;
      vm.transportationScheduleIdSelected = transportationSchedule.id;

      vm.onTransportationScheduleSelected({
        transportation: transportation,
        transportationSchedule: transportationSchedule,
      });
    };

    // private methods
    // -----------------------
    function getTransportations() {
      let params = {
        get: 'active',
        search: true,
        taxes: true,
        skip_check_role: true,
      };

      vm.loadingTransportations = true;
      TransportationService.getTransportations(params).then(function (data) {
        vm.transportations = data.items.filter(
          (transportation) => transportation.transportation_schedules.length > 0
        );

        vm.filteredTransportations = vm.transportations;

        // vm.transportationsCopy = angular.copy(vm.transportations);
        vm.loadingTransportations = false;
      });
    }

    function searchTransportationsNamesByText(transportation) {
      let filterByText = vm.filterByText.toLowerCase() || '';

      // Find by name
      if (
        transportation.name.toLowerCase().match(filterByText) ||
        (transportation.departure_location &&
          transportation.departure_location.name.toLowerCase().match(filterByText)) ||
        (transportation.arrival_location &&
          transportation.arrival_location.name.toLowerCase().match(filterByText))
      ) {
        return transportation;
      } else {
        // Find by schedules
        let schedules = [];

        if (transportation.transportation_schedules) {
          transportation.transportation_schedules.forEach(function (schedule) {
            let scheduleTime = moment(schedule.departure, 'HH:mm').format('h:mm');
            let filterTime = moment(filterByText, 'HH:mm').format('h:mm');

            if (scheduleTime === filterTime) {
              schedules.push(schedule);
            }
          });
        }

        transportation.transportation_schedules = schedules;

        return transportation;
      }
    }
  }
})();
